// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDC0ExOh_mqNk-IYjw1dl7GSTuX-Nt2Txg',
    authDomain: 'ywc17-countdown.firebaseapp.com',
    databaseURL: 'https://ywc17-countdown.firebaseio.com',
    projectId: 'ywc17-countdown',
    storageBucket: 'ywc17-countdown.appspot.com',
    messagingSenderId: '141244683442',
    appId: '1:141244683442:web:264f6b4cb073273b83e5ab',
    measurementId: 'G-ER39NZDYVN'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
